import { Injectable, Signal, computed, inject } from '@angular/core';
import { FeatureToggleOn, FeatureToggleParam } from '../shared/constants';
import { WINDOW } from '@lentau/ui-kit/core/tokens/window';
import { LocalStorageService } from '@lentau/ui-kit/core/services/storage/localstorage.service';
import { GrowthBookService, GrowthBookValue } from '@lentau/core/growth-book/shared';

@Injectable({
  providedIn: 'root',
})
export class FeatureToggleManagerService {
  private window = inject(WINDOW);
  private localStorageService = inject(LocalStorageService);
  private growthBookService = inject(GrowthBookService);

  public checkParams(toggles: string[], featureValue?: GrowthBookValue | boolean): Signal<boolean> {
    return computed(() => {
      return toggles.some((toggle: string) => {
        return this.checkParam(toggle, featureValue)();
      });
    });
  }

  public checkParam(toggle: string, featureValue?: GrowthBookValue | boolean): Signal<boolean> {
    return computed(() => {
      // Вызываем все проверки, чтобы computed отслеживал все зависимости
      const localStorage: boolean = this.checkLocalStorage(toggle);
      const urlQuery: boolean = this.checkUrlQuery(toggle);
      const growthBook: boolean = this.checkGrowthBook(toggle, featureValue);

      return localStorage || urlQuery || growthBook;
    });
  }

  private checkLocalStorage(featureToggle: string): boolean {
    const localStorageValue = this.localStorageService.getItem(this.getLocalStorageKey(featureToggle));
    return Number(localStorageValue) === FeatureToggleOn;
  }

  private checkUrlQuery(featureToggle: string): boolean {
    const queryParams: string[] = this.queryParams();

    const isQueryToggle: boolean = queryParams?.includes(featureToggle);

    if (isQueryToggle) {
      this.localStorageService.setItem(this.getLocalStorageKey(featureToggle), FeatureToggleOn.toString());
    }

    return isQueryToggle || false;
  }

  private getLocalStorageKey(featureToggle: string): string {
    return `${FeatureToggleParam}_${featureToggle}`;
  }

  private queryParams(): string[] {
    const params = new URLSearchParams(this.window.location.search);
    return params.get(FeatureToggleParam)?.split(';');
  }

  private checkGrowthBook(toggle: string, featureValue?: GrowthBookValue | boolean): boolean {
    return this.growthBookService.checkFeature(toggle, featureValue);
  }
}
